export const SQLSCRIPTEXECUTED_DELETE_RESET = 'SQLSCRIPTEXECUTED_DELETE_RESET'
export const SQLSCRIPTEXECUTED_DELETE_SET_ERROR = 'SQLSCRIPTEXECUTED_DELETE_SET_ERROR'
export const SQLSCRIPTEXECUTED_DELETE_SET_DELETED = 'SQLSCRIPTEXECUTED_DELETE_SET_DELETED'
export const SQLSCRIPTEXECUTED_DELETE_TOGGLE_LOADING = 'SQLSCRIPTEXECUTED_DELETE_TOGGLE_LOADING'
